<div class="row g-3">
 <!-- Año -->
 <div class="col-6">
    <label class="form-label">Año a reportar</label>
    <select
      class="form-select"
      [(ngModel)]="selectedYear"
      (ngModelChange)="onYearModelChange($event)"
    >
      <option [ngValue]="null" disabled>Seleccione</option>
      <option *ngFor="let year of years" [ngValue]="year">
        {{ year }}
      </option>
    </select>
  </div>

  <!-- Semestre -->
  <div class="col-6">
    <label class="form-label">Semestre a reportar</label>
    <select
      class="form-select"
      [(ngModel)]="selectedSemester"
      (ngModelChange)="onSemesterModelChange($event)"
    >
      <option [ngValue]="null" disabled>Seleccione</option>
      <option *ngFor="let semester of semesters" [ngValue]="semester">
        {{ semester.name }}
      </option>
    </select>
  </div>
</div>